import { type FC } from 'react';

import { StyledDots } from './Dots.styled';
import type { DotsProps } from './types';

const Dots: FC<DotsProps> = ({ color = 'grey', size = 'md', className }) => (
  <StyledDots $color={color} $size={size} className={className} />
);

Dots.displayName = 'Dots';

export default Dots;
